import { render } from "./QuizItemDob.vue?vue&type=template&id=337a2a37"
import script from "./QuizItemDob.vue?vue&type=script&lang=js"
export * from "./QuizItemDob.vue?vue&type=script&lang=js"

import "./QuizItemDob.vue?vue&type=style&index=0&id=337a2a37&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__